import {
  Action,
  ActionType,
  ICreateVenuesResponse,
} from "models/vaccine/createVenues";
import createReducer from "../../../createReducer";

export interface CreateVenuesReducerType {
  loading: boolean;
  error?: string;
  createVenuesResponse?: ICreateVenuesResponse;
}

const defaultState: CreateVenuesReducerType = {
  loading: false,
  error: undefined,
  createVenuesResponse: undefined,
};

export const createVenuesReducer = createReducer<CreateVenuesReducerType>(
  defaultState,
  {
    [ActionType.VACCINE_CREATE_VENUES](state: CreateVenuesReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.VACCINE_CREATE_VENUES_ERROR](
      state: CreateVenuesReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.VACCINE_CREATE_VENUES_SUCCESS](
      state: CreateVenuesReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        createVenuesResponse: action.payload,
      };
    },

    [ActionType.VACCINE_CREATE_VENUES_RESET](state: CreateVenuesReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        createVenuesResponse: undefined,
      };
    },
  }
);
